import { useRecoilCallback, useRecoilValue } from 'recoil';
// import { useNavigate } from 'react-router-dom';

// import { sessionCartState } from '../../../Cart/atoms';
import {
	percomaticState,
	initAndLinkProgressState,
	initAndLinkProgressMessageState,
	transactionLoadedState
} from '../../../atoms';

import { useAppDispatch } from '../../../reduxstore/hooks';
import { useGetUnavailableProductsLazyQuery } from '../../../graphql';
import { setUnavailableProductIds } from '../../../domains/UI/store/slice';
import { storeIdState } from '../../atoms';

export const useSetStoreId = (
	onComplete?: () => void
): [currentStoreId: number, setStoreId: (storeId: number) => void] => {
	// const navigate = useNavigate();
	const dispatch = useAppDispatch();
	const currentStoreId = useRecoilValue(storeIdState);
	const [getUnavailableProducts] = useGetUnavailableProductsLazyQuery({
		fetchPolicy: 'network-only',
		onCompleted: data => {
			dispatch(
				setUnavailableProductIds(
					data.unavailableProducts.map(product => product.productId)
				)
			);
		}
	});

	const setStoreId = useRecoilCallback(
		({ set, reset }) =>
			(storeId: number) => {
				if (storeId === currentStoreId) return;

				set(storeIdState, storeId);
				reset(percomaticState);
				// reset(sessionCartState);
				reset(initAndLinkProgressState);
				reset(initAndLinkProgressMessageState);
				reset(transactionLoadedState);
				// navigate('/');
				getUnavailableProducts({ variables: { storeId } });

				onComplete && onComplete();
			},
		[onComplete, currentStoreId, getUnavailableProducts]
		// [navigate, onComplete]
	);

	return [currentStoreId, setStoreId];
};
